import * as actions from './actions';
import update from 'react/lib/update';
import * as dailyReportActionConsts from '../actions';

export const initState = {
	isLoading: false,
  signature: null
}


export default (state=initState, action) => {
  switch (action.type) {
    case dailyReportActionConsts.DAILY_REPORT_GET_SUCCESS:
      return update(state, {
        signature: {
          $set: action.signature
        }
    });
    case actions.SAVE_SIGNATURE_REQUEST:
      return update(state, {
        isLoading: {
          $set: true
        }
    });
    case actions.SAVE_SIGNATURE_SUCCESS:
      return update(state, {
        isLoading: {
          $set: false
        },
				signature: {
					$set: action.signature
				}
    });
    case actions.SAVE_SIGNATURE_FAILURE:
      return update(state, {
        isLoading: {
          $set: false
        }
    });
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/Signature/reducer.js